import { Component, inject, output, signal, ViewChild } from '@angular/core';
import { ModalComponent } from '@peca/design-system';
import { ReasonRemoveOrder } from '../../../values/reson-remove-order.value';
import { FormControl, FormGroup } from '@angular/forms';
import { ToastService, Validators } from '@peca/commons';

export interface OnConfirmProps {
  id: string;
  justification: string;
}

@Component({
  selector: 'peca-fiscal-panel-modal-remove-order',
  templateUrl: './fiscal-panel-modal-remove-order.component.html',
  styleUrls: ['./fiscal-panel-modal-remove-order.component.scss'],
  standalone: false,
})
export class FiscalPanelModalRemoveOrderComponent {
  @ViewChild('modal') modal!: ModalComponent;

  confirm = output<OnConfirmProps>();
  commerceReference = signal('');
  orderId = signal('');

  toast = inject(ToastService);
  reasonRemoveOrder = ReasonRemoveOrder;
  reasonRemoveOrderValue = Object.values(this.reasonRemoveOrder);

  form = new FormGroup({
    reason: new FormControl<string>('', [Validators.required]),
  });

  get formValue() {
    return {
      reason: this.form.get('reason')?.value || '',
    };
  }

  onDismiss() {
    this.form.reset();
    this.modal.close();
  }

  open(id: string, commerceReference: string) {
    this.commerceReference.set(commerceReference);
    this.orderId.set(id);
    this.modal.open();
  }

  onClickConfirm(id: string, reason: string) {
    if (this.form.invalid) return this.toast.warning('Por favor, preencha todos os campos obrigatórios.');
    this.form.reset();
    this.confirm.emit({ id, justification: reason });
    this.modal.close();
  }
}
